/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/

//NO SE PARA QUE SIRVE ESTO
/*(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();*/

//Slider de abajo
function actualizarSlidesConReviews() {
    // Selecciona todos los elementos rs-slide dentro del slider específico
    const slides = document.querySelectorAll('#rev_slider_22_1_forcefullwidth rs-slide');

    slides.forEach(slide => {
        const dataKey = slide.getAttribute('data-key').replace('rs-', '').replace(/-/g, '');

        if (dataKey) {
            // Realiza la solicitud a TrustShop para obtener los reviews
            obtenerReviews(dataKey, function(reviews) {
                if (reviews) {
                    // Calcular la calificación promedio de las reseñas
                    const averageRating = calcularCalificacionPromedio(reviews);

                    // Actualizar el slide con la calificación promedio
                    mostrarCalificacionPromedio(slide, averageRating, reviews.length);
                } else {
                    console.error('No se encontraron reseñas para el producto con dataKey:', dataKey);
                }
            });
        }
    });
}
//Obtiene raiting de los productos
function obtenerReviews(dataKey, callback) {
    const url = 'https://ts-storefront.trustshop.workers.dev/storefront/reviews?product_id=' + dataKey;

    fetch(url)
        .then(response => response.json())
        .then(data => {
            if (data && data.data && Array.isArray(data.data) && data.data.length > 0) {
                callback(data.data);
              //console.log(data);
            } else {
                callback(null);
                console.error('Error: La respuesta no contiene reseñas o el array está vacío:', data);
            }
        })
        .catch(error => {
            console.error('Error al obtener los reviews:', error);
            callback(null);
        });
}
//Promedio de raiting
function calcularCalificacionPromedio(reviews) {
    if (!reviews || reviews.length === 0) {
        return 0;
    }

    const totalStars = reviews.reduce((sum, review) => sum + review.star, 0);
    const averageRating = totalStars / reviews.length;
    return averageRating;
}

function mostrarCalificacionPromedio(slide, averageRating, totalReviews) {
    const reviewContainer = document.createElement('div');
    reviewContainer.classList.add('review-container');

    const averageRatingElement = document.createElement('div');
    averageRatingElement.classList.add('average-rating');

    // Determinar el texto para el número de reseñas
    const reviewsText = totalReviews === 1 ? 'Rating' : 'Ratings';

    // Crear elementos span para el texto del rating y el número de reseñas
    const ratingText = document.createElement('span');
    ratingText.classList.add('rating-number');
    ratingText.textContent = `${averageRating.toFixed(0)}`;

    const reviewsCount = document.createElement('span');
    reviewsCount.classList.add('rating-reviews');
    reviewsCount.textContent = `${totalReviews} ${reviewsText}`;

    const collectionSe = document.createElement('h5');
    collectionSe.classList.add('collectionSe');
    collectionSe.textContent = 'Serum';

    // Añadir el elemento span del rating y el número de reseñas al div averageRatingElement
    averageRatingElement.appendChild(collectionSe);
    averageRatingElement.appendChild(ratingText);
    averageRatingElement.innerHTML += generarEstrellasHTML(averageRating);
    averageRatingElement.appendChild(reviewsCount);

    // Añadir el contenedor de la reseña al contenedor del slide
    reviewContainer.appendChild(averageRatingElement);
    reviewContainer.appendChild(averageRatingElement);
    //console.log(slide);

    const ratingDiv = slide.querySelector('.rating-pr');
    if (ratingDiv) {
        // Limpiar cualquier contenido anterior en el div 'rating'
        ratingDiv.innerHTML = '';
        ratingDiv.appendChild(reviewContainer);
    } else {
        console.error('No se encontró el div con id "rating" en el slide:', slide);
    }
}



function generarEstrellasHTML(rating) {
    const starFull = '<span class="star full">&#9733;</span>';
    const starEmpty = '<span class="star empty">&#9734;</span>';
    const starHalf = '<span class="star half">&#9733;</span>'; // Elemento de media estrella
    let starsHTML = '';

    for (let i = 0; i < 5; i++) {
        if (i < Math.floor(rating)) {
            starsHTML += starFull;
        } else if (i < rating) {
            starsHTML += starHalf;
        } else {
            starsHTML += starEmpty;
        }
    }

    return starsHTML;
}

window.addEventListener('load', () => {
    const interval = setInterval(() => {
        const slides = document.querySelectorAll('rs-slide');
        if (slides.length > 0) {
            clearInterval(interval); // Detener la comprobación una vez que se encuentran elementos
            actualizarSlidesConReviews();
        }
    }, 100); // Comprobar cada 100 ms
});

// Configura los detalles de tu tienda y el token de acceso público
const storeDomain = 'https://rabbitsanddragons.com';
const apiVersion = '2024-04';
const publicAccessToken = 'b85a1ffaba20e4ff58fe45c5d35c0d86';

async function addToCart(variantId, button) {
    console.log(variantId);
    const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            items: [
                {
                    id: variantId,
                    quantity: 1
                }
            ]
        })
    });

    if (!response.ok) {
        const errorData = await response.json();
        console.error('Error al agregar al carrito:', errorData);
        button.textContent = 'Error al añadir';
    } else {
        button.textContent = 'Se ha añadido al carrito';
    }
}

async function fetchAllProducts() {
    const query = `
    {
      products(first: 10) {
        edges {
          node {
            id
            title
            priceRange {
              minVariantPrice {
                amount
                currencyCode
              }
            }
            collections(first: 1) {
              edges {
                node {
                  title
                }
              }
            }
            variants(first: 1) {
              edges {
                node {
                  id
                }
              }
            }
          }
        }
      }
    }`;

    const response = await fetch(`${storeDomain}/api/${apiVersion}/graphql.json`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': publicAccessToken
        },
        body: JSON.stringify({ query })
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    const products = data.data.products.edges.map(edge => {
        const product = edge.node;
        const collection = product.collections.edges[0] ? product.collections.edges[0].node.title : 'Sin categoría';
        const price = parseFloat(product.priceRange.minVariantPrice.amount);
        const currencyCode = product.priceRange.minVariantPrice.currencyCode;
        const variantId = product.variants.edges[0].node.id.match(/\/([^\/]+)$/)[1];

        const idNumber = product.id.match(/\/([^\/]+)$/)[1];

        return {
            id: idNumber,
            title: product.title,
            price: price,
            currency: currencyCode,
            collection: collection,
            variants: [{ id: variantId }]
        };
    });

    return products;
}

function setupButtons() {
    document.querySelectorAll('.add-button-car').forEach(button => {
        const variantId = button.getAttribute('data-variant-id');
        button.addEventListener('click', function() {
            addToCart(variantId, this);
        });
    });
}
//Funcion para traer los productos en el primer slider
/*window.onload = function() {
    setTimeout(async function() {
        try {
            const products = await fetchAllProducts();

            products.forEach(product => {
                const productTitleFormatted = product.title.toLowerCase().replace(/\s+/g, '-');
                const productDivId = `producto-${productTitleFormatted}`;
                const addDivId = `add-${productTitleFormatted}`;
                const productDiv = document.getElementById(productDivId);

                if (productDiv) {
                    const hiddenElement = document.createElement('div');
                    hiddenElement.style.display = 'none';
                    hiddenElement.setAttribute('data-name', product.id);

                    const priceElement = document.createElement('h4');
                    priceElement.textContent = `$${formatPrice(product.price)} ${product.currency}`;

                    const collectionElement = document.createElement('h5');
                    collectionElement.textContent = `${product.collection}`;

                    const dataKey = product.id;
                    const slide = productDivId;
                    const ratingDivs = document.createElement('div');
                    ratingDivs.classList.add('rating-pr');
                    // Realiza la solicitud a TrustShop para obtener los reviews
                    obtenerReviews(dataKey, function(reviews) {
                        if (reviews) {
                            //console.log(reviews);
                            const totalReviewsD = reviews.length;
                            // Calcular la calificación promedio de las reseñas
                            const averageRating = calcularCalificacionPromedio(reviews);
                            //console.log(averageRating);
                            // Actualizar el slide con la calificación promedio
    
                            const reviewContainer = document.createElement('div');
                            reviewContainer.classList.add('review-container');
                        
                            const averageRatingElement = document.createElement('div');
                            averageRatingElement.classList.add('average-rating');
                        
                            // Determinar el texto para el número de reseñas
                            const reviewsText = totalReviewsD === 1 ? 'Rating' : 'Ratings';
                        
                            // Crear elementos span para el texto del rating y el número de reseñas
                            const ratingText = document.createElement('span');
                            ratingText.classList.add('rating-number');
                            ratingText.textContent = averageRating.toFixed(0);
                        
                            const reviewsCount = document.createElement('span');
                            reviewsCount.classList.add('rating-reviews');
                            reviewsCount.textContent = totalReviewsD + ' ' + reviewsText;
                        
                            // Añadir el elemento span del rating y el número de reseñas al div averageRatingElement
                            averageRatingElement.appendChild(ratingText);
                            averageRatingElement.innerHTML += generarEstrellasHTML(averageRating);
                            averageRatingElement.appendChild(reviewsCount);
                        
                            // Añadir el contenedor de la reseña al contenedor del slide
                            reviewContainer.appendChild(averageRatingElement);
    
                            ratingDivs.appendChild(reviewContainer);
    
                        } else {
                            console.error('No se encontraron reseñas para el producto con dataKey:', dataKey);
                        }
                    });

                    const addToCartButton = document.createElement('button');
                    addToCartButton.textContent = 'Agregar al carrito';
                    addToCartButton.classList.add('add-button-car', 'rev-btn');
                    addToCartButton.setAttribute('data-variant-id', product.variants[0].id);

                    const addDiv = document.getElementById(addDivId);

                    productDiv.innerHTML = '';
                    productDiv.appendChild(hiddenElement);
                    productDiv.appendChild(priceElement);
                    productDiv.appendChild(collectionElement);
                    productDiv.appendChild(ratingDivs);
                    if (addDiv) {
                        addDiv.innerHTML = '';
                        addDiv.appendChild(addToCartButton);
                    } else {
                        console.error(`No se encontró el contenedor para el botón con ID ${addDivId}`);
                    }
                } else {
                    console.error(`No se encontró el contenedor para el producto con ID ${product.title}`);
                }
            });

            // Configurar los botones al cargar los productos
            setupButtons();

            // Usar MutationObserver para observar cambios en el DOM
            const observer = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                        setupButtons(); // Configurar los botones después de cualquier cambio en el DOM
                    }
                });
            });

            observer.observe(document.body, { childList: true, subtree: true });

        } catch (error) {
            console.error('Error al obtener los productos:', error);
        }
    }, 500);
};*/

function formatPrice(price) {
    return price.toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

